export default "__VITE_ASSET__DeI0YB2g__"